import { styled, Typography } from '@mui/material';

export const PageTitleStyled = styled('h2')(({ theme }) => ({
  padding: theme.spacing(4, 0),
})) as typeof Typography;
